import { createSelector } from '@reduxjs/toolkit';

export const selectAllAcknowledgements = state => state.acknowledgements.byId;

export const selectAllUserAcknowledgementIds = state => state.acknowledgements.all.data;

export const selectAllUserAcknowledgementsFetched = state =>
  !!state.acknowledgements.all.__lastFetched;

/**
 * [selectAllAcknowledgementTypes] - returns all the acknowledgments for various message types that this user has
 * accepted
 *
 * @returns {string[]}
 */

export const selectAllAcknowledgementTypes = createSelector(
  [selectAllAcknowledgements, selectAllUserAcknowledgementIds],
  (acksById, ackIds) => ackIds.map(id => acksById[id].data.message_type)
);
